import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import {
  ICreateICDGroup,
  IICDGroup,
  IUpdateICDGroup,
} from '../../../../pages/icd-groups/interfaces/icd-groups.interface';
import { TreeNode } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class IcdCodeService {
  constructor(private readonly apiService: ApiService) {}

  getList() {
    return this.apiService.get<any>('icd-code');
  }

  getTreeList() {
    return this.apiService.get<TreeNode[]>('icd-code/get-icd-code-tree-list');
  }

  createICDGroup(data: ICreateICDGroup) {
    return this.apiService.post<IICDGroup>(
      'icd-code/create-icd-code-group',
      data
    );
  }

  deleteICDGroup(id: number) {
    return this.apiService.delete<{isSuccess:boolean}>(`icd-code/delete-icd-code-group/${id}`);
  }

  updateICDGroup(data: IUpdateICDGroup) {
    return this.apiService.post<IICDGroup>(
      'icd-code/update-icd-code-group',
      data
    );
  }

  getICDGroupList() {
    return this.apiService.get<IICDGroup[]>('icd-code/getList-icd-code-group');
  }

  getSelectableList() {
    return this.apiService.get<any>('icd-code/get-selectable-code-list');
  }
}
